// Le suivi du produit : ce qui a changé (/versions) et ce qui est prévu (/roadmap).
// On y arrive en cliquant sur le numéro de version, et chaque page mène à l'autre.
import type { ReactNode } from 'react';
import { buttonClass, Chip, Eyebrow } from '../components/ui';
import { Link } from '../router';
import { APP_VERSION } from '../version';
import { VERSIONS } from './changelog';
import { ROADMAP } from './roadmap';
import './updates.css';

const fmtDate = (day: string) =>
  new Date(`${day}T12:00:00`).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

function UpdatesHead({ title, intro, link }: { title: string; intro: string; link: ReactNode }) {
  return (
    <div className="zy-page-head">
      <div className="zy-page-head__texte">
        <Eyebrow>
          <Link to="/">Portefeuille</Link> · Suivi du produit
        </Eyebrow>
        <h1 className="t-h1">{title}</h1>
        <p className="zy-intro">{intro}</p>
      </div>
      <div className="zy-page-head__actions">{link}</div>
    </div>
  );
}

export function VersionsPage() {
  return (
    <div className="app-main updates">
      <UpdatesHead
        title="Versions"
        intro={`Vous utilisez la version ${APP_VERSION}. Voici tout ce qui a changé, de la plus récente à la plus ancienne.`}
        link={<Link to="/roadmap" className={buttonClass('ghost')}>Voir la roadmap</Link>}
      />
      {VERSIONS.map((v) => (
        <section key={v.version} className="zy-card updates-card" aria-labelledby={`version-${v.version}`}>
          <div className="zy-card__tete">
            <h2 className="zy-h3" id={`version-${v.version}`}>
              Version {v.version}
              {v.version === APP_VERSION ? <Chip state="succes">Actuelle</Chip> : null}
            </h2>
            <span className="zy-texte-muet">{fmtDate(v.date)}</span>
          </div>
          <ul className="updates-list">
            {v.changes.map((change, i) => <li key={i}>{change}</li>)}
          </ul>
        </section>
      ))}
    </div>
  );
}

export function RoadmapPage() {
  return (
    <div className="app-main updates">
      <UpdatesHead
        title="Roadmap"
        intro="Ce que nous prévoyons pour Zygosight. Les priorités peuvent évoluer avec vos retours."
        link={<Link to="/versions" className={buttonClass('ghost')}>Voir les versions</Link>}
      />
      {ROADMAP.map((stage) => (
        <section key={stage.title} className="zy-card updates-card">
          <h2 className="zy-h3">{stage.title}</h2>
          <ul className="updates-roadmap">
            {stage.items.map((item) => (
              <li key={item.name}>
                <strong>{item.name}</strong>
                <span className="zy-texte-doux">{item.detail}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
